var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatListNumbered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11.8333V10.9583H2.20833V10.5208H1.33333V9.64582H2.20833V9.20832H0.75V8.33332H2.5C2.66528 8.33332 2.80382 8.38923 2.91563 8.50103C3.02743 8.61284 3.08333 8.75138 3.08333 8.91666V9.49999C3.08333 9.66527 3.02743 9.80381 2.91563 9.91562C2.80382 10.0274 2.66528 10.0833 2.5 10.0833C2.66528 10.0833 2.80382 10.1392 2.91563 10.251C3.02743 10.3628 3.08333 10.5014 3.08333 10.6667V11.25C3.08333 11.4153 3.02743 11.5538 2.91563 11.6656C2.80382 11.7774 2.66528 11.8333 2.5 11.8333H0.75ZM0.75 7.74999V6.14582C0.75 5.98055 0.805903 5.842 0.917708 5.7302C1.02951 5.61839 1.16806 5.56249 1.33333 5.56249H2.20833V5.12499H0.75V4.24999H2.5C2.66528 4.24999 2.80382 4.30589 2.91563 4.4177C3.02743 4.5295 3.08333 4.66805 3.08333 4.83332V5.85416C3.08333 6.01943 3.02743 6.15798 2.91563 6.26978C2.80382 6.38159 2.66528 6.43749 2.5 6.43749H1.625V6.87499H3.08333V7.74999H0.75ZM1.625 3.66666V1.04166H0.75V0.166656H2.5V3.66666H1.625ZM4.25 10.0833V8.91666H11.25V10.0833H4.25ZM4.25 6.58332V5.41666H11.25V6.58332H4.25ZM4.25 3.08332V1.91666H11.25V3.08332H4.25Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListNumbered);
export default __webpack_public_path__ + "static/media/format_list_numbered.7529d2db.svg";
export { ForwardRef as ReactComponent };